'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);

var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};
});

unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ConcurrentMode;
var reactIs_production_min_4 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_5 = reactIs_production_min.ContextProvider;
var reactIs_production_min_6 = reactIs_production_min.Element;
var reactIs_production_min_7 = reactIs_production_min.ForwardRef;
var reactIs_production_min_8 = reactIs_production_min.Fragment;
var reactIs_production_min_9 = reactIs_production_min.Lazy;
var reactIs_production_min_10 = reactIs_production_min.Memo;
var reactIs_production_min_11 = reactIs_production_min.Portal;
var reactIs_production_min_12 = reactIs_production_min.Profiler;
var reactIs_production_min_13 = reactIs_production_min.StrictMode;
var reactIs_production_min_14 = reactIs_production_min.Suspense;
var reactIs_production_min_15 = reactIs_production_min.isValidElementType;
var reactIs_production_min_16 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_17 = reactIs_production_min.isConcurrentMode;
var reactIs_production_min_18 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_19 = reactIs_production_min.isContextProvider;
var reactIs_production_min_20 = reactIs_production_min.isElement;
var reactIs_production_min_21 = reactIs_production_min.isForwardRef;
var reactIs_production_min_22 = reactIs_production_min.isFragment;
var reactIs_production_min_23 = reactIs_production_min.isLazy;
var reactIs_production_min_24 = reactIs_production_min.isMemo;
var reactIs_production_min_25 = reactIs_production_min.isPortal;
var reactIs_production_min_26 = reactIs_production_min.isProfiler;
var reactIs_production_min_27 = reactIs_production_min.isStrictMode;
var reactIs_production_min_28 = reactIs_production_min.isSuspense;

var reactIs_development = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

Object.defineProperty(exports, '__esModule', { value: true });

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;

var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace;
var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' ||
  // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE);
}

/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

{
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`lowPriorityWarning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var lowPriorityWarning$1 = lowPriorityWarning;

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;
    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;
          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;
              default:
                return $$typeof;
            }
        }
      case REACT_LAZY_TYPE:
      case REACT_MEMO_TYPE:
      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}

// AsyncMode is deprecated along with isAsyncMode
var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;

var hasWarnedAboutDeprecatedIsAsyncMode = false;

// AsyncMode should be deprecated
function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true;
      lowPriorityWarning$1(false, 'The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }
  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.typeOf = typeOf;
exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isValidElementType = isValidElementType;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
  })();
}
});

unwrapExports(reactIs_development);
var reactIs_development_1 = reactIs_development.typeOf;
var reactIs_development_2 = reactIs_development.AsyncMode;
var reactIs_development_3 = reactIs_development.ConcurrentMode;
var reactIs_development_4 = reactIs_development.ContextConsumer;
var reactIs_development_5 = reactIs_development.ContextProvider;
var reactIs_development_6 = reactIs_development.Element;
var reactIs_development_7 = reactIs_development.ForwardRef;
var reactIs_development_8 = reactIs_development.Fragment;
var reactIs_development_9 = reactIs_development.Lazy;
var reactIs_development_10 = reactIs_development.Memo;
var reactIs_development_11 = reactIs_development.Portal;
var reactIs_development_12 = reactIs_development.Profiler;
var reactIs_development_13 = reactIs_development.StrictMode;
var reactIs_development_14 = reactIs_development.Suspense;
var reactIs_development_15 = reactIs_development.isValidElementType;
var reactIs_development_16 = reactIs_development.isAsyncMode;
var reactIs_development_17 = reactIs_development.isConcurrentMode;
var reactIs_development_18 = reactIs_development.isContextConsumer;
var reactIs_development_19 = reactIs_development.isContextProvider;
var reactIs_development_20 = reactIs_development.isElement;
var reactIs_development_21 = reactIs_development.isForwardRef;
var reactIs_development_22 = reactIs_development.isFragment;
var reactIs_development_23 = reactIs_development.isLazy;
var reactIs_development_24 = reactIs_development.isMemo;
var reactIs_development_25 = reactIs_development.isPortal;
var reactIs_development_26 = reactIs_development.isProfiler;
var reactIs_development_27 = reactIs_development.isStrictMode;
var reactIs_development_28 = reactIs_development.isSuspense;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

var printWarning = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
  var has = Function.call.bind(Object.prototype.hasOwnProperty);

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes;

var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".rc-Search{height:3rem;text-align:center;margin:.5rem 1.25rem 0;flex-shrink:0}.rc-Search-input{background-size:auto 55%;border-width:0;border-bottom:1px solid gray;color:gray;font-family:sans-serif;height:2.3rem;line-height:1.5;outline-width:0;text-transform:capitalize;text-align:center;width:100%}.rc-Search-input::placeholder{color:gray}.rc-Search-button{display:none}";
styleInject(css);

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var Search = function (_Component) {
  inherits(Search, _Component);

  function Search() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, Search);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = Search.__proto__ || Object.getPrototypeOf(Search)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      searchText: ''
    }, _this.handleInput = function (evt) {
      _this.setState({ searchText: evt.target.value });
    }, _this.handleSubmit = function (e) {
      e.preventDefault();
      _this.props.onSearchSubmit(_this.state.searchText);
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(Search, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React__default.createElement(
        'form',
        { className: 'rc-Search', onSubmit: this.handleSubmit, action: '' },
        React__default.createElement('input', {
          className: 'rc-Search-input u-p5',
          defaultValue: this.state.searchText,
          onInput: this.handleInput,
          placeholder: this.state.placeholder || this.props.placeholder,
          ref: function ref(_ref2) {
            return _this2._input = _ref2;
          },
          type: 'search'
        }),
        React__default.createElement(
          'button',
          { className: 'rc-Search-button' },
          'Search'
        )
      );
    }
  }]);
  return Search;
}(React.Component);

Search.displayName = 'Search';
Search.propTypes = {
  noAutoFocus: propTypes.bool,
  onSearchSubmit: propTypes.func.isRequired,
  placeholder: propTypes.string,
  lastSearch: propTypes.string
};
Search.defaultProps = {
  lastSearch: '',
  placeholder: 'Search'
};

var css$1 = ".rc-cta-Alternative,.rc-cta-Primary,.rc-cta-Quaternary,.rc-cta-Secondary,.rc-cta-Tertiary{cursor:pointer;font-family:SharpSans,Helvetica,Arial,Trebuchet MS,sans-serif;border:none;padding:.65rem}.rc-cta-Alternative:focus,.rc-cta-Primary:focus,.rc-cta-Quaternary:focus,.rc-cta-Secondary:focus,.rc-cta-Tertiary:focus{outline:0}.rc-cta-Alternative,.rc-cta-Primary,.rc-cta-Quaternary,.rc-cta-Secondary,.rc-cta-Tertiary{border-radius:6px;display:inline-block;font-size:.833rem;font-weight:500;padding:1rem;position:relative;text-transform:capitalize}.rc-cta-Primary{background-color:#1f51cf;border-color:#1f51cf;color:#fff;fill:#fff;text-align:center}@media (min-width:1024px){.rc-cta-Primary.is-active,.rc-cta-Primary:active,.rc-cta-Primary:hover{background-color:#1840a3}}.rc-cta-Secondary{background-color:#fff;border:1px solid #1f51cf;color:#1f51cf;fill:#1f51cf;text-align:center}@media (min-width:1024px){.rc-cta-Secondary.is-active,.rc-cta-Secondary:active,.rc-cta-Secondary:hover{color:#fff;background-color:#1f51cf}}.rc-cta-Tertiary{transition:all .1s ease-in-out;color:#1f51cf;border:1px solid #1f51cf;background:transparent}.rc-cta-Tertiary svg g,.rc-cta-Tertiary svg path{fill:#1f51cf;stroke-width:0}.rc-cta-Tertiary:hover{color:#fff;fill:#1f51cf;background-color:#1f51cf}@media (min-width:1024px){.rc-cta-Tertiary:active,.rc-cta-Tertiary:hover{color:#fff;fill:#1f51cf;background-color:#1f51cf}.rc-cta-Tertiary:active svg g,.rc-cta-Tertiary:active svg path,.rc-cta-Tertiary:hover svg g,.rc-cta-Tertiary:hover svg path{fill:#fff;stroke-width:0}}.rc-cta-Quaternary{color:#1f51cf;background-color:transparent;text-transform:capitalize}@media (min-width:1024px){.rc-cta-Quaternary:active,.rc-cta-Quaternary:hover{color:#1840a3}}.rc-cta-Alternative{padding:.55rem 1rem;border:none;color:#fff;background-color:gray}@media (min-width:1024px){.rc-cta-Alternative:active,.rc-cta-Alternative:hover{background-color:#4a4a4a}}.rc-cta-Alternative.is-active{background-color:#4a4a4a}.rc-cta-Alternative--isDisabled,.rc-cta-Alternative[disabled],.rc-cta-Primary--isDisabled,.rc-cta-Primary[disabled],.rc-cta-Secondary--isDisabled,.rc-cta-Secondary[disabled],.rc-cta-Tertiary--isDisabled,.rc-cta-Tertiary[disabled]{opacity:.25;pointer-events:none}";
styleInject(css$1);

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (typeof undefined === 'function' && typeof undefined.amd === 'object' && undefined.amd) {
		// register as 'classnames', consistent with npm package name
		undefined('classnames', [], function () {
			return classNames;
		});
	} else {
		window.classNames = classNames;
	}
}());
});

var Button = function Button(props) {
  var buttonClasses = classnames('rc-cta', {
    'rc-cta-Primary': props.primary,
    'rc-cta-Secondary': props.secondary
  });
  return React__default.createElement(
    'button',
    {
      className: buttonClasses,
      onClick: props.onButtonClick },
    props.text
  );
};

Button.propTypes = {
  onButtonClick: propTypes.func,
  text: propTypes.string
};

Button.defaultProps = {
  onButtonClick: function onButtonClick() {},
  text: 'Submit'
};

Button.displayName = 'Button';

var css$2 = ".rc-ProductColorSwatch{border:1px solid #d5d5d5;border-radius:3px;cursor:pointer;display:inline-block;height:25px;position:relative;width:25px}.rc-ProductColorSwatch-trim{border-bottom-right-radius:2px;border-top-right-radius:2px;position:absolute;bottom:0;right:0;top:0;width:33%}.rc-ProductColorSwatch:focus,.rc-ProductColorSwatch:hover{border:1px solid #444;outline:none}.rc-ProductColorSwatch--selected{border:1px solid #444}.rc-ProductColorSwatch--selected:after{background-color:transparent;background-image:url(data:image/svg+xml;base64,Cjxzdmcgd2lkdGg9IjM0cHgiIGhlaWdodD0iMjZweCIgdmlld0JveD0iMCAwIDM0IDI2IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgo8ZGVmcz4KICA8cGF0aCBkPSJNMzIuMjA2NDExNCw1LjM3NjUwODkxIEwxNC4zMTk4MDk3LDIzLjMyNjUzODIgQzEzLjMwNDk2NzEsMjQuMzQxMzgwOSAxMS43MTkyNzU1LDI0LjM0MTM4MDkgMTAuNzA0NDMyOCwyMy4zMjY1MzgyIEwxLjc2MTEzMTk4LDE0LjMxOTgwOTcgQzAuNzQ2Mjg5MzM4LDEzLjMwNDk2NzEgMC43NDYyODkzMzgsMTEuNzE5Mjc1NSAxLjc2MTEzMTk4LDEwLjcwNDQzMjggQzIuNzc1OTc0NjMsOS42ODk1OTAxNiA0LjM2MTY2NjI3LDkuNjg5NTkwMTYgNS4zNzY1MDg5MSwxMC43MDQ0MzI4IEwxMi41NDM4MzUxLDE3Ljg3MTc1OSBMMjguNjU0NDYyMSwxLjc2MTEzMTk4IEMyOS42NjkzMDQ4LDAuNzQ2Mjg5MzM4IDMxLjI1NDk5NjQsMC43NDYyODkzMzggMzIuMjY5ODM5LDEuNzYxMTMxOTggQzMzLjI4NDY4MTcsMi43NzU5NzQ2MyAzMy4yMjEyNTQsNC4zNjE2NjYyNyAzMi4yMDY0MTE0LDUuMzc2NTA4OTEgTDMyLjIwNjQxMTQsNS4zNzY1MDg5MSBaIiBpZD0iY2hlY2siPjwvcGF0aD4KICA8bWFzayBpZD0iY2hlY2stbWFzayIgbWFza0NvbnRlbnRVbml0cz0idXNlclNwYWNlT25Vc2UiIG1hc2tVbml0cz0ib2JqZWN0Qm91bmRpbmdCb3giIHg9Ii0xIiB5PSItMSIgd2lkdGg9IjM0IiBoZWlnaHQ9IjI1LjA4NzY3MDIiPgogICAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjM0IiBoZWlnaHQ9IjI1LjA4NzY3MDIiIGZpbGw9IndoaXRlIj48L3JlY3Q+CiAgICA8dXNlIHhsaW5rOmhyZWY9IiNjaGVjayIgZmlsbD0iYmxhY2siPjwvdXNlPgogIDwvbWFzaz4KPC9kZWZzPgogIDxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHVzZSBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHhsaW5rOmhyZWY9IiNjaGVjayI+PC91c2U+CiAgICA8dXNlIHN0cm9rZT0iIzJDM0U1MCIgbWFzaz0idXJsKCNjaGVjay1tYXNrKSIgc3Ryb2tlLXdpZHRoPSIyIiB4bGluazpocmVmPSIjY2hlY2siPjwvdXNlPgogIDwvZz4KPC9zdmc+Cg==);background-origin:border-box;background-position:50%;background-repeat:no-repeat;background-size:64%;border:0;bottom:0;content:\"\";left:0;position:absolute;right:0;top:0;z-index:1}";
styleInject(css$2);

var backgroundColor = function backgroundColor(rgb) {
  return "rgb(" + [rgb.r, rgb.g, rgb.b] + ")";
};

var Trim = function Trim(_ref) {
  var rgb = _ref.rgb;

  var styles = {
    backgroundColor: backgroundColor(rgb)
  };
  return React__default.createElement("div", { className: "rc-ProductColorSwatch-trim", style: styles });
};

var ProductColorSwatch = function ProductColorSwatch(_ref2) {
  var className = _ref2.className,
      rgb = _ref2.rgb,
      selected = _ref2.selected,
      trimRgb = _ref2.trimRgb,
      onMouseEnter = _ref2.onMouseEnter,
      onMouseLeave = _ref2.onMouseLeave,
      onFocus = _ref2.onFocus;

  var styles = {
    backgroundColor: backgroundColor(rgb)
  };

  return React__default.createElement(
    "div",
    {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onFocus: onFocus,
      onBlur: onFocus,
      tabIndex: "0",
      className: "rc-ProductColorSwatch\n                  " + (selected ? "rc-ProductColorSwatch--selected" : "") + "\n                  " + className,
      style: styles
    },
    trimRgb && typeof trimRgb.r === "number" ? React__default.createElement(Trim, { rgb: trimRgb }) : ""
  );
};

ProductColorSwatch.propTypes = {
  onFocus: propTypes.func,
  onMouseEnter: propTypes.func,
  onMouseLeave: propTypes.func,
  rgb: propTypes.shape({
    r: propTypes.number.isRequired,
    g: propTypes.number.isRequired,
    b: propTypes.number.isRequired
  }),
  selected: propTypes.bool,
  trimRgb: propTypes.shape({
    r: propTypes.number,
    g: propTypes.number,
    b: propTypes.number
  })
};

var clipboard = createCommonjsModule(function (module, exports) {
/*!
 * clipboard.js v2.0.4
 * https://zenorocha.github.io/clipboard.js
 * 
 * Licensed MIT © Zeno Rocha
 */
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory();
})(commonjsGlobal, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipboardAction = __webpack_require__(1);

var _clipboardAction2 = _interopRequireDefault(_clipboardAction);

var _tinyEmitter = __webpack_require__(3);

var _tinyEmitter2 = _interopRequireDefault(_tinyEmitter);

var _goodListener = __webpack_require__(4);

var _goodListener2 = _interopRequireDefault(_goodListener);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Base class which takes one or more elements, adds event listeners to them,
 * and instantiates a new `ClipboardAction` on each click.
 */
var Clipboard = function (_Emitter) {
    _inherits(Clipboard, _Emitter);

    /**
     * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
     * @param {Object} options
     */
    function Clipboard(trigger, options) {
        _classCallCheck(this, Clipboard);

        var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this));

        _this.resolveOptions(options);
        _this.listenClick(trigger);
        return _this;
    }

    /**
     * Defines if attributes would be resolved using internal setter functions
     * or custom functions that were passed in the constructor.
     * @param {Object} options
     */


    _createClass(Clipboard, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = typeof options.action === 'function' ? options.action : this.defaultAction;
            this.target = typeof options.target === 'function' ? options.target : this.defaultTarget;
            this.text = typeof options.text === 'function' ? options.text : this.defaultText;
            this.container = _typeof(options.container) === 'object' ? options.container : document.body;
        }

        /**
         * Adds a click event listener to the passed trigger.
         * @param {String|HTMLElement|HTMLCollection|NodeList} trigger
         */

    }, {
        key: 'listenClick',
        value: function listenClick(trigger) {
            var _this2 = this;

            this.listener = (0, _goodListener2.default)(trigger, 'click', function (e) {
                return _this2.onClick(e);
            });
        }

        /**
         * Defines a new `ClipboardAction` on each click event.
         * @param {Event} e
         */

    }, {
        key: 'onClick',
        value: function onClick(e) {
            var trigger = e.delegateTarget || e.currentTarget;

            if (this.clipboardAction) {
                this.clipboardAction = null;
            }

            this.clipboardAction = new _clipboardAction2.default({
                action: this.action(trigger),
                target: this.target(trigger),
                text: this.text(trigger),
                container: this.container,
                trigger: trigger,
                emitter: this
            });
        }

        /**
         * Default `action` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultAction',
        value: function defaultAction(trigger) {
            return getAttributeValue('action', trigger);
        }

        /**
         * Default `target` lookup function.
         * @param {Element} trigger
         */

    }, {
        key: 'defaultTarget',
        value: function defaultTarget(trigger) {
            var selector = getAttributeValue('target', trigger);

            if (selector) {
                return document.querySelector(selector);
            }
        }

        /**
         * Returns the support of the given action, or all actions if no action is
         * given.
         * @param {String} [action]
         */

    }, {
        key: 'defaultText',


        /**
         * Default `text` lookup function.
         * @param {Element} trigger
         */
        value: function defaultText(trigger) {
            return getAttributeValue('text', trigger);
        }

        /**
         * Destroy lifecycle.
         */

    }, {
        key: 'destroy',
        value: function destroy() {
            this.listener.destroy();

            if (this.clipboardAction) {
                this.clipboardAction.destroy();
                this.clipboardAction = null;
            }
        }
    }], [{
        key: 'isSupported',
        value: function isSupported() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['copy', 'cut'];

            var actions = typeof action === 'string' ? [action] : action;
            var support = !!document.queryCommandSupported;

            actions.forEach(function (action) {
                support = support && !!document.queryCommandSupported(action);
            });

            return support;
        }
    }]);

    return Clipboard;
}(_tinyEmitter2.default);

/**
 * Helper function to retrieve attribute value.
 * @param {String} suffix
 * @param {Element} element
 */


function getAttributeValue(suffix, element) {
    var attribute = 'data-clipboard-' + suffix;

    if (!element.hasAttribute(attribute)) {
        return;
    }

    return element.getAttribute(attribute);
}

module.exports = Clipboard;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _select = __webpack_require__(2);

var _select2 = _interopRequireDefault(_select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Inner class which performs selection from either `text` or `target`
 * properties and then executes copy or cut operations.
 */
var ClipboardAction = function () {
    /**
     * @param {Object} options
     */
    function ClipboardAction(options) {
        _classCallCheck(this, ClipboardAction);

        this.resolveOptions(options);
        this.initSelection();
    }

    /**
     * Defines base properties passed from constructor.
     * @param {Object} options
     */


    _createClass(ClipboardAction, [{
        key: 'resolveOptions',
        value: function resolveOptions() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            this.action = options.action;
            this.container = options.container;
            this.emitter = options.emitter;
            this.target = options.target;
            this.text = options.text;
            this.trigger = options.trigger;

            this.selectedText = '';
        }

        /**
         * Decides which selection strategy is going to be applied based
         * on the existence of `text` and `target` properties.
         */

    }, {
        key: 'initSelection',
        value: function initSelection() {
            if (this.text) {
                this.selectFake();
            } else if (this.target) {
                this.selectTarget();
            }
        }

        /**
         * Creates a fake textarea element, sets its value from `text` property,
         * and makes a selection on it.
         */

    }, {
        key: 'selectFake',
        value: function selectFake() {
            var _this = this;

            var isRTL = document.documentElement.getAttribute('dir') == 'rtl';

            this.removeFake();

            this.fakeHandlerCallback = function () {
                return _this.removeFake();
            };
            this.fakeHandler = this.container.addEventListener('click', this.fakeHandlerCallback) || true;

            this.fakeElem = document.createElement('textarea');
            // Prevent zooming on iOS
            this.fakeElem.style.fontSize = '12pt';
            // Reset box model
            this.fakeElem.style.border = '0';
            this.fakeElem.style.padding = '0';
            this.fakeElem.style.margin = '0';
            // Move element out of screen horizontally
            this.fakeElem.style.position = 'absolute';
            this.fakeElem.style[isRTL ? 'right' : 'left'] = '-9999px';
            // Move element to the same position vertically
            var yPosition = window.pageYOffset || document.documentElement.scrollTop;
            this.fakeElem.style.top = yPosition + 'px';

            this.fakeElem.setAttribute('readonly', '');
            this.fakeElem.value = this.text;

            this.container.appendChild(this.fakeElem);

            this.selectedText = (0, _select2.default)(this.fakeElem);
            this.copyText();
        }

        /**
         * Only removes the fake element after another click event, that way
         * a user can hit `Ctrl+C` to copy because selection still exists.
         */

    }, {
        key: 'removeFake',
        value: function removeFake() {
            if (this.fakeHandler) {
                this.container.removeEventListener('click', this.fakeHandlerCallback);
                this.fakeHandler = null;
                this.fakeHandlerCallback = null;
            }

            if (this.fakeElem) {
                this.container.removeChild(this.fakeElem);
                this.fakeElem = null;
            }
        }

        /**
         * Selects the content from element passed on `target` property.
         */

    }, {
        key: 'selectTarget',
        value: function selectTarget() {
            this.selectedText = (0, _select2.default)(this.target);
            this.copyText();
        }

        /**
         * Executes the copy operation based on the current selection.
         */

    }, {
        key: 'copyText',
        value: function copyText() {
            var succeeded = void 0;

            try {
                succeeded = document.execCommand(this.action);
            } catch (err) {
                succeeded = false;
            }

            this.handleResult(succeeded);
        }

        /**
         * Fires an event based on the copy operation result.
         * @param {Boolean} succeeded
         */

    }, {
        key: 'handleResult',
        value: function handleResult(succeeded) {
            this.emitter.emit(succeeded ? 'success' : 'error', {
                action: this.action,
                text: this.selectedText,
                trigger: this.trigger,
                clearSelection: this.clearSelection.bind(this)
            });
        }

        /**
         * Moves focus away from `target` and back to the trigger, removes current selection.
         */

    }, {
        key: 'clearSelection',
        value: function clearSelection() {
            if (this.trigger) {
                this.trigger.focus();
            }

            window.getSelection().removeAllRanges();
        }

        /**
         * Sets the `action` to be performed which can be either 'copy' or 'cut'.
         * @param {String} action
         */

    }, {
        key: 'destroy',


        /**
         * Destroy lifecycle.
         */
        value: function destroy() {
            this.removeFake();
        }
    }, {
        key: 'action',
        set: function set() {
            var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'copy';

            this._action = action;

            if (this._action !== 'copy' && this._action !== 'cut') {
                throw new Error('Invalid "action" value, use either "copy" or "cut"');
            }
        }

        /**
         * Gets the `action` property.
         * @return {String}
         */
        ,
        get: function get() {
            return this._action;
        }

        /**
         * Sets the `target` property using an element
         * that will be have its content copied.
         * @param {Element} target
         */

    }, {
        key: 'target',
        set: function set(target) {
            if (target !== undefined) {
                if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object' && target.nodeType === 1) {
                    if (this.action === 'copy' && target.hasAttribute('disabled')) {
                        throw new Error('Invalid "target" attribute. Please use "readonly" instead of "disabled" attribute');
                    }

                    if (this.action === 'cut' && (target.hasAttribute('readonly') || target.hasAttribute('disabled'))) {
                        throw new Error('Invalid "target" attribute. You can\'t cut text from elements with "readonly" or "disabled" attributes');
                    }

                    this._target = target;
                } else {
                    throw new Error('Invalid "target" value, use a valid Element');
                }
            }
        }

        /**
         * Gets the `target` property.
         * @return {String|HTMLElement}
         */
        ,
        get: function get() {
            return this._target;
        }
    }]);

    return ClipboardAction;
}();

module.exports = ClipboardAction;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function select(element) {
    var selectedText;

    if (element.nodeName === 'SELECT') {
        element.focus();

        selectedText = element.value;
    }
    else if (element.nodeName === 'INPUT' || element.nodeName === 'TEXTAREA') {
        var isReadOnly = element.hasAttribute('readonly');

        if (!isReadOnly) {
            element.setAttribute('readonly', '');
        }

        element.select();
        element.setSelectionRange(0, element.value.length);

        if (!isReadOnly) {
            element.removeAttribute('readonly');
        }

        selectedText = element.value;
    }
    else {
        if (element.hasAttribute('contenteditable')) {
            element.focus();
        }

        var selection = window.getSelection();
        var range = document.createRange();

        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);

        selectedText = selection.toString();
    }

    return selectedText;
}

module.exports = select;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

function E () {
  // Keep this empty so it's easier to inherit from
  // (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}

E.prototype = {
  on: function (name, callback, ctx) {
    var e = this.e || (this.e = {});

    (e[name] || (e[name] = [])).push({
      fn: callback,
      ctx: ctx
    });

    return this;
  },

  once: function (name, callback, ctx) {
    var self = this;
    function listener () {
      self.off(name, listener);
      callback.apply(ctx, arguments);
    }
    listener._ = callback;
    return this.on(name, listener, ctx);
  },

  emit: function (name) {
    var data = [].slice.call(arguments, 1);
    var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
    var i = 0;
    var len = evtArr.length;

    for (i; i < len; i++) {
      evtArr[i].fn.apply(evtArr[i].ctx, data);
    }

    return this;
  },

  off: function (name, callback) {
    var e = this.e || (this.e = {});
    var evts = e[name];
    var liveEvents = [];

    if (evts && callback) {
      for (var i = 0, len = evts.length; i < len; i++) {
        if (evts[i].fn !== callback && evts[i].fn._ !== callback)
          liveEvents.push(evts[i]);
      }
    }

    // Remove event from queue to prevent memory leak
    // Suggested by https://github.com/lazd
    // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910

    (liveEvents.length)
      ? e[name] = liveEvents
      : delete e[name];

    return this;
  }
};

module.exports = E;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var is = __webpack_require__(5);
var delegate = __webpack_require__(6);

/**
 * Validates all params and calls the right
 * listener function based on its target type.
 *
 * @param {String|HTMLElement|HTMLCollection|NodeList} target
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listen(target, type, callback) {
    if (!target && !type && !callback) {
        throw new Error('Missing required arguments');
    }

    if (!is.string(type)) {
        throw new TypeError('Second argument must be a String');
    }

    if (!is.fn(callback)) {
        throw new TypeError('Third argument must be a Function');
    }

    if (is.node(target)) {
        return listenNode(target, type, callback);
    }
    else if (is.nodeList(target)) {
        return listenNodeList(target, type, callback);
    }
    else if (is.string(target)) {
        return listenSelector(target, type, callback);
    }
    else {
        throw new TypeError('First argument must be a String, HTMLElement, HTMLCollection, or NodeList');
    }
}

/**
 * Adds an event listener to a HTML element
 * and returns a remove listener function.
 *
 * @param {HTMLElement} node
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNode(node, type, callback) {
    node.addEventListener(type, callback);

    return {
        destroy: function() {
            node.removeEventListener(type, callback);
        }
    }
}

/**
 * Add an event listener to a list of HTML elements
 * and returns a remove listener function.
 *
 * @param {NodeList|HTMLCollection} nodeList
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenNodeList(nodeList, type, callback) {
    Array.prototype.forEach.call(nodeList, function(node) {
        node.addEventListener(type, callback);
    });

    return {
        destroy: function() {
            Array.prototype.forEach.call(nodeList, function(node) {
                node.removeEventListener(type, callback);
            });
        }
    }
}

/**
 * Add an event listener to a selector
 * and returns a remove listener function.
 *
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Object}
 */
function listenSelector(selector, type, callback) {
    return delegate(document.body, selector, type, callback);
}

module.exports = listen;


/***/ }),
/* 5 */
/***/ (function(module, exports) {

/**
 * Check if argument is a HTML element.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.node = function(value) {
    return value !== undefined
        && value instanceof HTMLElement
        && value.nodeType === 1;
};

/**
 * Check if argument is a list of HTML elements.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.nodeList = function(value) {
    var type = Object.prototype.toString.call(value);

    return value !== undefined
        && (type === '[object NodeList]' || type === '[object HTMLCollection]')
        && ('length' in value)
        && (value.length === 0 || exports.node(value[0]));
};

/**
 * Check if argument is a string.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.string = function(value) {
    return typeof value === 'string'
        || value instanceof String;
};

/**
 * Check if argument is a function.
 *
 * @param {Object} value
 * @return {Boolean}
 */
exports.fn = function(value) {
    var type = Object.prototype.toString.call(value);

    return type === '[object Function]';
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var closest = __webpack_require__(7);

/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function _delegate(element, selector, type, callback, useCapture) {
    var listenerFn = listener.apply(this, arguments);

    element.addEventListener(type, listenerFn, useCapture);

    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    }
}

/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */
function delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === 'function') {
        return _delegate.apply(null, arguments);
    }

    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === 'function') {
        // Use `document` as the first parameter, then apply arguments
        // This is a short way to .unshift `arguments` without running into deoptimizations
        return _delegate.bind(null, document).apply(null, arguments);
    }

    // Handle Selector-based usage
    if (typeof elements === 'string') {
        elements = document.querySelectorAll(elements);
    }

    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function (element) {
        return _delegate(element, selector, type, callback, useCapture);
    });
}

/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */
function listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = closest(e.target, selector);

        if (e.delegateTarget) {
            callback.call(element, e);
        }
    }
}

module.exports = delegate;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

var DOCUMENT_NODE_TYPE = 9;

/**
 * A polyfill for Element.matches()
 */
if (typeof Element !== 'undefined' && !Element.prototype.matches) {
    var proto = Element.prototype;

    proto.matches = proto.matchesSelector ||
                    proto.mozMatchesSelector ||
                    proto.msMatchesSelector ||
                    proto.oMatchesSelector ||
                    proto.webkitMatchesSelector;
}

/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */
function closest (element, selector) {
    while (element && element.nodeType !== DOCUMENT_NODE_TYPE) {
        if (typeof element.matches === 'function' &&
            element.matches(selector)) {
          return element;
        }
        element = element.parentNode;
    }
}

module.exports = closest;


/***/ })
/******/ ]);
});
});

unwrapExports(clipboard);

var reactClipboard = createCommonjsModule(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory(clipboard, propTypes, React__default);
})(commonjsGlobal, function(__WEBPACK_EXTERNAL_MODULE_clipboard__, __WEBPACK_EXTERNAL_MODULE_prop_types__, __WEBPACK_EXTERNAL_MODULE_react__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./index.js":
/*!******************!*\
  !*** ./index.js ***!
  \******************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {
eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ \"react\");\n/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! prop-types */ \"prop-types\");\n/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);\nfunction _typeof(obj) { if (typeof Symbol === \"function\" && typeof Symbol.iterator === \"symbol\") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === \"function\" && obj.constructor === Symbol && obj !== Symbol.prototype ? \"symbol\" : typeof obj; }; } return _typeof(obj); }\n\nfunction _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }\n\nfunction _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError(\"Cannot call a class as a function\"); } }\n\nfunction _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if (\"value\" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }\n\nfunction _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }\n\nfunction _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === \"object\" || typeof call === \"function\")) { return call; } return _assertThisInitialized(self); }\n\nfunction _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError(\"this hasn't been initialised - super() hasn't been called\"); } return self; }\n\nfunction _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }\n\nfunction _inherits(subClass, superClass) { if (typeof superClass !== \"function\" && superClass !== null) { throw new TypeError(\"Super expression must either be null or a function\"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }\n\nfunction _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }\n\nfunction _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }\n\n\n\n\nvar ClipboardButton =\n/*#__PURE__*/\nfunction (_React$Component) {\n  _inherits(ClipboardButton, _React$Component);\n\n  function ClipboardButton() {\n    _classCallCheck(this, ClipboardButton);\n\n    return _possibleConstructorReturn(this, _getPrototypeOf(ClipboardButton).apply(this, arguments));\n  }\n\n  _createClass(ClipboardButton, [{\n    key: \"propsWith\",\n    value: function propsWith(regexp) {\n      var remove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;\n      var object = {};\n      Object.keys(this.props).forEach(function (key) {\n        if (key.search(regexp) !== -1) {\n          var objectKey = remove ? key.replace(regexp, '') : key;\n          object[objectKey] = this.props[key];\n        }\n      }, this);\n      return object;\n    }\n  }, {\n    key: \"componentWillUnmount\",\n    value: function componentWillUnmount() {\n      this.clipboard && this.clipboard.destroy();\n    }\n  }, {\n    key: \"componentDidMount\",\n    value: function componentDidMount() {\n      // Support old API by trying to assign this.props.options first;\n      var options = this.props.options || this.propsWith(/^option-/, true);\n      var element = react__WEBPACK_IMPORTED_MODULE_0___default.a.version.match(/0\\.13(.*)/) ? this.refs.element.getDOMNode() : this.element;\n\n      var Clipboard = __webpack_require__(/*! clipboard */ \"clipboard\");\n\n      this.clipboard = new Clipboard(element, options);\n      var callbacks = this.propsWith(/^on/, true);\n      Object.keys(callbacks).forEach(function (callback) {\n        this.clipboard.on(callback.toLowerCase(), this.props['on' + callback]);\n      }, this);\n    }\n  }, {\n    key: \"render\",\n    value: function render() {\n      var _this = this;\n\n      var attributes = _objectSpread({\n        title: this.props.title || '',\n        type: this.getType(),\n        className: this.props.className || '',\n        style: this.props.style || {},\n        ref: function ref(element) {\n          _this.element = element;\n        },\n        onClick: this.props.onClick\n      }, this.propsWith(/^data-/), this.propsWith(/^button-/, true));\n\n      return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(this.getComponent(), attributes, this.props.children);\n    }\n  }, {\n    key: \"getType\",\n    value: function getType() {\n      if (this.getComponent() === 'button' || this.getComponent() === 'input') {\n        return this.props.type || 'button';\n      } else {\n        return undefined;\n      }\n    }\n  }, {\n    key: \"getComponent\",\n    value: function getComponent() {\n      return this.props.component || 'button';\n    }\n  }]);\n\n  return ClipboardButton;\n}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);\n\n_defineProperty(ClipboardButton, \"propTypes\", {\n  options: function options(props, propName, componentName) {\n    var options = props[propName];\n\n    if (options && _typeof(options) !== 'object' || Array.isArray(options)) {\n      return new Error(\"Invalid props '\".concat(propName, \"' supplied to '\").concat(componentName, \"'. \") + \"'\".concat(propName, \"' is not an object.\"));\n    }\n\n    if (props['option-text'] !== undefined) {\n      var optionText = props['option-text'];\n\n      if (typeof optionText !== 'function') {\n        return new Error(\"Invalid props 'option-text' supplied to '\".concat(componentName, \"'. \") + \"'option-text' is not a function.\");\n      }\n    }\n  },\n  title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,\n  type: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,\n  className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,\n  style: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,\n  component: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,\n  children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.element, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.element), prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object])\n});\n\n_defineProperty(ClipboardButton, \"defaultProps\", {\n  onClick: function onClick() {}\n  /* Returns a object with all props that fulfill a certain naming pattern\n   *\n   * @param {RegExp} regexp - Regular expression representing which pattern\n   *                          you'll be searching for.\n   * @param {Boolean} remove - Determines if the regular expression should be\n   *                           removed when transmitting the key from the props\n   *                           to the new object.\n   *\n   * e.g:\n   *\n   * // Considering:\n   * // this.props = {option-foo: 1, onBar: 2, data-foobar: 3 data-baz: 4};\n   *\n   * // *RegExps not using // so that this comment doesn't break up\n   * this.propsWith(option-*, true); // returns {foo: 1}\n   * this.propsWith(on*, true); // returns {Bar: 2}\n   * this.propsWith(data-*); // returns {data-foobar: 1, data-baz: 4}\n   */\n\n});\n\n/* harmony default export */ __webpack_exports__[\"default\"] = (ClipboardButton);\n\n//# sourceURL=webpack://ReactClipboard/./index.js?");

/***/ }),

/***/ "clipboard":
/*!********************************************************************************************************!*\
  !*** external {"root":"ClipboardJS","amd":"clipboard","commonjs":"clipboard","commonjs2":"clipboard"} ***!
  \********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = __WEBPACK_EXTERNAL_MODULE_clipboard__;\n\n//# sourceURL=webpack://ReactClipboard/external_%7B%22root%22:%22ClipboardJS%22,%22amd%22:%22clipboard%22,%22commonjs%22:%22clipboard%22,%22commonjs2%22:%22clipboard%22%7D?");

/***/ }),

/***/ "prop-types":
/*!*********************************************************************************************************!*\
  !*** external {"root":"PropTypes","amd":"prop-types","commonjs":"prop-types","commonjs2":"prop-types"} ***!
  \*********************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = __WEBPACK_EXTERNAL_MODULE_prop_types__;\n\n//# sourceURL=webpack://ReactClipboard/external_%7B%22root%22:%22PropTypes%22,%22amd%22:%22prop-types%22,%22commonjs%22:%22prop-types%22,%22commonjs2%22:%22prop-types%22%7D?");

/***/ }),

/***/ "react":
/*!**************************************************************************************!*\
  !*** external {"root":"React","amd":"react","commonjs":"react","commonjs2":"react"} ***!
  \**************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

eval("module.exports = __WEBPACK_EXTERNAL_MODULE_react__;\n\n//# sourceURL=webpack://ReactClipboard/external_%7B%22root%22:%22React%22,%22amd%22:%22react%22,%22commonjs%22:%22react%22,%22commonjs2%22:%22react%22%7D?");

/***/ })

/******/ });
});
});

var ClipboardButton = unwrapExports(reactClipboard);

var css$3 = ".rc-ShareMenuItem{display:flex;flex-direction:column;align-items:center;justify-content:center}.rc-ShareMenuItem-icon{flex:1 0 3rem}.rc-ShareMenuItem-icon svg{max-width:2.5rem;width:100%}.rc-ShareMenuItem-name{flex:1 0 1rem;font-size:.833rem}";
styleInject(css$3);

var ShareMenuItem = function ShareMenuItem(props) {
  return React__default.createElement(
    'a',
    {
      className: 'rc-ShareMenuItem',
      href: props.destination,
      onClick: props.action,
      target: props.target },
    React__default.createElement(
      'div',
      { className: 'rc-ShareMenuItem-icon' },
      React__default.createElement(props.itemImageName, null)
    ),
    React__default.createElement(
      'div',
      { className: 'rc-ShareMenuItem-name' },
      props.itemText
    )
  );
};

ShareMenuItem.propTypes = {
  itemText: propTypes.string.isRequired,
  action: propTypes.func,
  destination: propTypes.string,
  target: propTypes.string
};

ShareMenuItem.defaultProps = {
  target: 'self'
};

ShareMenuItem.displayName = 'ShareMenuItem';

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends$1.apply(this, arguments);
}
var emailIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = objectWithoutProperties(_ref, ["styles"]);
  return React__default.createElement("svg", _extends$1({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.45 57.45",
    fill: "#ef8034"
  }, props), React__default.createElement("path", {
    d: "M28.73 0a28.73 28.73 0 1 0 28.72 28.73A28.73 28.73 0 0 0 28.73 0zM9.17 29l34.92-11.9-25.4 15.66zm11.57 13.9v-7.53L25 37.13zm12.83-3.34l-12-5.31 23.87-17.52z"
  }));
});

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends$2.apply(this, arguments);
}
var facebookIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = objectWithoutProperties(_ref, ["styles"]);
  return React__default.createElement("svg", _extends$2({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.45 57.45",
    fill: "#224581"
  }, props), React__default.createElement("path", {
    d: "M28.73 0a28.73 28.73 0 1 0 28.72 28.73A28.73 28.73 0 0 0 28.73 0zm7.45 23.37l-.39 5h-5.18v17.58h-6.54V28.41h-3.49v-5h3.49V20c0-1.5 0-3.8 1.13-5.23a6.34 6.34 0 0 1 5.42-2.54 22 22 0 0 1 6.25.62L36 18a11.79 11.79 0 0 0-2.81-.39c-1.36 0-2.57.48-2.57 1.85v3.94h5.56z"
  }));
});

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends$3.apply(this, arguments);
}
var printIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === undefined ? {} : _ref$styles,
      props = objectWithoutProperties(_ref, ["styles"]);
  return React__default.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.81 59.81"
  }, props), React__default.createElement("g", {
    "data-name": "Layer 2"
  }, React__default.createElement("g", {
    "data-name": "24-print this"
  }, React__default.createElement("path", {
    fill: "none",
    d: "M14.56 37.59H21v6.47h17.82v-6.47h6.47V23.5H14.56zm7.7-3.85h15.36v9H22.25zm-3.1-7.62a1.89 1.89 0 1 1 0 3.78H19v.06a1.92 1.92 0 1 1 .1-3.85z"
  }), React__default.createElement("path", {
    fill: "#ef8034",
    className: styles["cls-2"] || "cls-2",
    d: "M19.05 30v-.06h.08a1.37 1.37 0 1 0-.05.06z"
  }), React__default.createElement("path", {
    fill: "#ef8034",
    d: "M22.25 33.74h15.36v9.02H22.25zM34.38 20.3h3.92l-3.83-3.84-.09 3.84z"
  }), React__default.createElement("path", {
    fill: "#ef8034",
    d: "M29.9 0a29.9 29.9 0 1 0 29.9 29.9A29.9 29.9 0 0 0 29.9 0zM21 15.82h13.38a.65.65 0 0 1 .45.19l3.78 3.83a.65.65 0 0 1 .19.45v1.92H21zm24.28 21.77h-6.46v6.47H21v-6.47h-6.44V23.5h30.72z"
  }))));
});

function _extends$4() {
  _extends$4 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends$4.apply(this, arguments);
}
var pinterestIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = objectWithoutProperties(_ref, ["styles"]);
  return React__default.createElement("svg", _extends$4({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.45 57.37",
    fill: "#c7242e"
  }, props), React__default.createElement("path", {
    d: "M28.65 0a28.68 28.68 0 0 0-11.49 54.95 25.18 25.18 0 0 1 .5-6.59l3.69-15.63a11 11 0 0 1-.92-4.53c0-4.22 2.47-7.38 5.53-7.38 2.61 0 3.87 2 3.87 4.31 0 2.62-1.68 6.55-2.53 10.18a4.44 4.44 0 0 0 4.51 5.47c5.44 0 9.1-7 9.1-15.25 0-6.32-4.22-11-11.93-11-8.7 0-14.12 6.48-14.12 13.7a8.29 8.29 0 0 0 1.89 5.63 1.39 1.39 0 0 1 .41 1.6c-.14.53-.45 1.8-.58 2.3a1 1 0 0 1-1.43.72c-4-1.63-5.87-6-5.87-11 0-8.15 6.87-17.92 20.5-17.92 11 0 18.16 7.93 18.16 16.43 0 11.26-6.25 19.66-15.47 19.66-3.1 0-6-1.68-7-3.57 0 0-1.67 6.61-2 7.88a24 24 0 0 1-2.89 6.15A28.68 28.68 0 1 0 28.65 0"
  }));
});

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };return _extends$5.apply(this, arguments);
}
var twitterIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = objectWithoutProperties(_ref, ["styles"]);
  return React__default.createElement("svg", _extends$5({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 57.45 57.45",
    fill: "#4099FF"
  }, props), React__default.createElement("path", {
    d: "M28.73 0a28.73 28.73 0 1 0 28.72 28.73A28.73 28.73 0 0 0 28.73 0zm12.1 22.9v.81c0 8.27-6.29 17.8-17.8 17.8a17.72 17.72 0 0 1-9.57-2.81 12.65 12.65 0 0 0 9.26-2.59 6.26 6.26 0 0 1-5.84-4.34 6.2 6.2 0 0 0 1.2.11 6.11 6.11 0 0 0 1.65-.22 6.26 6.26 0 0 1-5-6.15 6.26 6.26 0 0 0 2.84.78 6.26 6.26 0 0 1-1.94-8.37 17.75 17.75 0 0 0 12.9 6.54 6.26 6.26 0 0 1 10.66-5.76 12.5 12.5 0 0 0 4-1.51 6.26 6.26 0 0 1-2.75 3.46 12.51 12.51 0 0 0 3.53-1h-.06a12.68 12.68 0 0 1-3.09 3.25zm3.12-3.24h.06z"
  }));
});

var Breakpoints = {
  xs: {
    max: 349
  },
  sm: {
    min: 350,
    max: 699
  },
  md: {
    min: 700,
    max: 849
  },
  lg: {
    min: 850,
    max: 1023
  },
  xl: {
    min: 1024
  }
};

var MediaQueries = {
  onlySmallAndXSmall: '(min-width: ' + Breakpoints.xs.max + 'px) and (max-width: ' + Breakpoints.md.min + 'px)',
  onlyMedium: '(min-width: ' + Breakpoints.md.min + 'px) and (max-width: ' + Breakpoints.lg.min + 'px)',
  onlyLarge: '(min-width: ' + Breakpoints.lg.min + 'px) and (max-width: ' + Breakpoints.xl.min + 'px)',
  mediumAndBelow: '(max-width: ' + Breakpoints.md.max + 'px)',
  mediumAndAbove: '(min-width: ' + Breakpoints.md.min + 'px)',
  largeAndAbove: '(min-width: ' + Breakpoints.lg.min + 'px)'
};

var css$4 = ".rc-Input{font-family:SharpSans,Helvetica,Arial,Trebuchet MS,sans-serif;width:100%;margin:.5rem 0 .25rem;font-size:.833rem;line-height:1.5;padding:0 .5rem;border-radius:3px;appearance:none}.rc-Input::placeholder{color:#b7b7b7}.rc-Input:focus{outline:none;border-color:#1f51cf}.rc-Input{height:2.5rem;border:1px solid #b7b7b7}.rc-Input--error{border-color:#ee3524}.rc-Input-helpText{color:gray;line-height:1rem;font-size:.694rem;font-weight:500}.rc-Input-errorLabel{color:#ee3524;font-size:.833rem;line-height:1rem}.rc-ShareMenu{align-items:stretch;display:flex;flex-direction:column;margin:1rem 12.5% 0;width:75%}.rc-ShareMenu-list{display:flex;flex:0 0 4rem;justify-content:space-between;width:100%;max-width:315px;margin:0 auto}.rc-ShareMenu-inputGroup{padding-top:.625rem;display:flex;flex-direction:row;flex:1 1 4rem;text-align:center}.rc-ShareMenu-input.rc-Input{border:1px solid #b7b7b7;border-radius:3px;margin-right:.25rem;display:block}.rc-ShareMenu-inputLink.rc-cta-Primary{border-top-left-radius:0;border-bottom-left-radius:0;height:2.5rem;line-height:2.5rem;margin:.5rem 0;padding-bottom:0;padding-top:0}.rc-ShareMenu-inputLink.rc-cta-Primary>div{display:flex;align-items:center;justify-content:center}";
styleInject(css$4);

var FACEBOOK_URL = 'http://www.facebook.com/sharer.php';
var TWITTER_URL = 'http://twitter.com/share?text=Check+out+my+one-of-a-kind+custom+design+from+@customink:&url=';
var PINTEREST_URL = 'http://www.pinterest.com/pin/create/button/';

var ShareMenu = function (_Component) {
  inherits(ShareMenu, _Component);

  function ShareMenu() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ShareMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ShareMenu.__proto__ || Object.getPrototypeOf(ShareMenu)).call.apply(_ref, [this].concat(args))), _this), _this.mediaQueryHandler = function (query) {
      _this.setState({ largeAndAbove: query.matches });
    }, _this.shareLink = function () {
      var compositeId = _this.props.compositeId;
      var designName = _this.props.designName;
      var designHost = _this.props.designHost;
      return designHost + '/designs/' + designName + '/' + compositeId;
    }, _this.copyLink = function () {
      var mediaBreakpointString = _this.state.largeAndAbove ? 'desktop' : 'mobile';
      var trackingParams = '?pc=EMAIL-40778&utm_campaign=shared%20design&utm_source=share%20link&utm_medium=shared%20design&utm_content=shared%20';
      var customInkPath = _this.props.isInternal ? '/hotlink' : '/share' + trackingParams + mediaBreakpointString;
      return '' + _this.shareLink() + customInkPath;
    }, _this.pinterestURL = function () {
      var customInkPath = '/social/';
      var params = '%3Futm_campaign=shared%20design%26utm_source=pinterest%26utm_medium=shared%20design%26description=Checkout+my+one-of-a-kind+custom+design+from+www.customink.com';
      var uriWithParams = PINTEREST_URL + '?url=' + _this.shareLink() + customInkPath + params;
      return uriWithParams;
    }, _this.facebookURL = function () {
      var customInkPath = '/social/';
      var facebookParams = '%3Futm_campaign=shared%20design%26utm_source=facebook%26utm_medium=shared%20design';
      var uriWithParams = FACEBOOK_URL + '?u=' + _this.shareLink() + customInkPath + facebookParams;
      return uriWithParams;
    }, _this.twitterURL = function () {
      var customInkPath = '/social';
      var encodedShareLink = encodeURI('' + _this.shareLink() + customInkPath);
      var uri = '' + TWITTER_URL + encodedShareLink + '%3F%26related=customink%26utm_campaign=shared%2Bdesign%26utm_source=twitter%26utm_medium=shared%2Bdesign';
      return uri;
    }, _this.printURL = function () {
      var compositeId = _this.props.compositeId;
      var designURL = _this.props.designURL;
      return designURL + '/proof_page?cid=' + compositeId;
    }, _this.shareWithEmail = function (e) {
      _this.props.shareWithEmailAction();
      if (_this.props.onShareWithEmail && _this.state.largeAndAbove) {
        _this.props.onShareWithEmail();
      } else {
        var designName = _this.props.designName;
        var emailSubject = 'subject=Check out my ' + designName + ' design from CustomInk!';
        var linkWithParams = _this.shareLink() + '/share/%3Fpc=EMAIL-40778%26utm_campaign=shared%20design%26utm_source=share%20link%26utm_medium=shared%20design%26utm_content=shared%20mobile';
        var emailURI = 'mailto:?' + emailSubject + '&body=' + linkWithParams;
        _this.doRedirect(emailURI);
      }
    }, _this.doRedirect = function (href) {
      window.location.href = href;
    }, _this.onSuccess = function (e) {
      _this.props.shareWithLinkAction();
      e.trigger.textContent = 'Copied';
      window.setTimeout(function () {
        e.trigger.textContent = 'Copy';
      }, 2000);
      e.clearSelection();
    }, _this.onError = function (e) {
      _this.props.shareWithLinkAction();
      var shareLink = document.getElementById('shareLink');
      shareLink.focus();
      shareLink.setSelectionRange(0, shareLink.value.length);
      e.trigger.textContent = 'CMD-C To Copy';
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ShareMenu, [{
    key: 'UNSAFE_componentWillMount',
    value: function UNSAFE_componentWillMount() {
      this.largeAndAbove = window.matchMedia(MediaQueries.largeAndAbove);
      this.mediaQueryHandler(this.largeAndAbove);
      this.largeAndAbove.addListener(this.mediaQueryHandler);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.largeAndAbove.removeListener(this.mediaQueryHandler);
    }

    // added this method so the emailURI can be tested

  }, {
    key: 'render',
    value: function render() {
      return React__default.createElement(
        'article',
        { className: 'rc-ShareMenu' },
        React__default.createElement('div', { className: 'rc-ShareMenu-spacer' }),
        React__default.createElement(
          'div',
          { className: 'rc-ShareMenu-list' },
          React__default.createElement(ShareMenuItem, {
            action: this.shareWithEmail,
            itemImageName: emailIcon,
            itemText: 'Email'
          }),
          React__default.createElement(ShareMenuItem, {
            action: this.props.facebookAction,
            destination: this.facebookURL(),
            itemImageName: facebookIcon,
            itemText: 'Share',
            target: 'blank'
          }),
          React__default.createElement(ShareMenuItem, {
            action: this.props.twitterAction,
            destination: this.twitterURL(),
            itemImageName: twitterIcon,
            itemText: 'Tweet',
            target: 'blank'
          }),
          React__default.createElement(ShareMenuItem, {
            action: this.props.pinterestAction,
            destination: this.pinterestURL(),
            itemImageName: pinterestIcon,
            itemText: 'Pin',
            target: 'blank'
          }),
          this.state.largeAndAbove && this.props.printOption && React__default.createElement(ShareMenuItem, {
            action: this.props.printAction,
            destination: this.printURL(),
            itemImageName: printIcon,
            itemText: 'Print',
            target: 'blank'
          })
        ),
        React__default.createElement(
          'div',
          { className: 'rc-ShareMenu-inputGroup' },
          React__default.createElement('input', {
            className: 'rc-ShareMenu-input rc-Input',
            id: 'shareLink',
            name: 'text',
            readOnly: true,
            type: 'text',
            value: this.copyLink()
          }),
          React__default.createElement(
            'div',
            { className: 'rc-cta-Primary rc-ShareMenu-inputLink' },
            React__default.createElement(
              ClipboardButton,
              {
                component: 'div',
                'data-clipboard-target': '#shareLink',
                onError: this.onError,
                onSuccess: this.onSuccess },
              'Copy'
            )
          )
        )
      );
    }
  }]);
  return ShareMenu;
}(React.Component);

ShareMenu.displayName = 'ShareMenu';
ShareMenu.propTypes = {
  designName: propTypes.string.isRequired,
  designHost: propTypes.string.isRequired, //new
  designURL: propTypes.string, //new
  compositeId: propTypes.string,
  facebookAction: propTypes.func,
  pinterestAction: propTypes.func,
  printAction: propTypes.func,
  router: propTypes.shape({
    navigate: propTypes.func.isRequired
  }),
  shareWithEmailAction: propTypes.func,
  shareWithLinkAction: propTypes.func,
  twitterAction: propTypes.func,
  isInternal: propTypes.bool.isRequired, //new
  printOption: propTypes.bool, //new
  onShareWithEmail: propTypes.func //new
};
ShareMenu.defaultProps = {
  shareWithEmailAction: function shareWithEmailAction() {},
  shareWithLinkAction: function shareWithLinkAction() {},
  facebookAction: function facebookAction() {},
  pinterestAction: function pinterestAction() {},
  twitterAction: function twitterAction() {},
  printOption: true
};

function fieldErrorMessage(senderName, recipients, emailBody, allFields) {
  return senderName && recipients && emailBody ? allFields : senderName || recipients || emailBody;
}

function validateRecipients(recipients) {
  if (recipients === '') {
    return 'Email must not be blank.';
  } else return null;
}

function validateSenderName(name) {
  if (name === '') {
    return 'Name must not be blank.';
  } else return null;
}

function validateEmailBody(emailBody) {
  if (emailBody === '') {
    return 'Email message must not be blank.';
  } else return null;
}

var css$5 = ".rc-ShareEmailForm{align-items:stretch;background:#fff;display:flex;flex:1 1 0;flex-flow:column;margin:0;min-height:0;min-width:0;text-align:left}.rc-ShareEmailForm-fields{flex:1 1 auto;max-width:500px;padding:2rem 2rem 0}.rc-ShareEmailForm-submit{flex:0 0 auto;height:3rem}@media (min-width:850px){.rc-ShareEmailForm-submit{margin:.25rem}}.rc-ShareEmailForm-submit--disabled{background-color:#b7b7b7}.rc-ShareEmailForm-inputGroup{margin-bottom:1.5rem}.rc-ShareEmailForm-inputGroup--checkbox{align-items:center;display:flex}.rc-ShareEmailForm #emailBody{height:3.5rem}.rc-ShareEmailForm-input--checkbox{background-color:gray;margin-right:.25rem}";
styleInject(css$5);

function ShareEmailForm(_ref) {
  var onShareSuccess = _ref.onShareSuccess,
      onShareError = _ref.onShareError,
      onValidationError = _ref.onValidationError,
      compositeId = _ref.compositeId,
      designURL = _ref.designURL;

  // State
  var _useState = React.useState(''),
      _useState2 = slicedToArray(_useState, 2),
      senderName = _useState2[0],
      setSenderName = _useState2[1];

  var _useState3 = React.useState(null),
      _useState4 = slicedToArray(_useState3, 2),
      senderNameError = _useState4[0],
      setSenderNameError = _useState4[1];

  var _useState5 = React.useState(''),
      _useState6 = slicedToArray(_useState5, 2),
      recipients = _useState6[0],
      setRecipients = _useState6[1];

  var _useState7 = React.useState(null),
      _useState8 = slicedToArray(_useState7, 2),
      recipientsError = _useState8[0],
      setRecipientsError = _useState8[1];

  var _useState9 = React.useState('I just created this design. Take a look.'),
      _useState10 = slicedToArray(_useState9, 2),
      emailBody = _useState10[0],
      setEmailBody = _useState10[1];

  var _useState11 = React.useState(null),
      _useState12 = slicedToArray(_useState11, 2),
      emailBodyError = _useState12[0],
      setEmailBodyError = _useState12[1];

  // This sets mounted to true on mount and false on unmount


  var mountedRef = React.useRef(false);
  React.useEffect(function () {
    mountedRef.current = true;
    return function () {
      return mountedRef.current = false;
    };
  }, []);

  var onShareFailure = function onShareFailure(message) {
    setSenderNameError(null);
    setEmailBodyError(null);
    setRecipientsError(message);
    onValidationError(message);
  };

  var shareDesign = function shareDesign() {
    var modifiedRecipients = recipients.trim().replace(/\s+/g, '').toLowerCase();
    var url = designURL + '/designs/share/send_to_friends';
    var safeCallback = function safeCallback(cb) {
      if (mountedRef.current) {
        cb();
      }
    };
    return window.fetch(url, {
      method: 'post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        sender_name: senderName,
        composite_id: compositeId,
        recipients: modifiedRecipients,
        body: emailBody
      })
    }).then(function (response) {
      if (response.ok) {
        return response.json().then(function (data) {
          if (data.success) {
            safeCallback(function () {
              return onShareSuccess(data);
            });
          } else {
            safeCallback(function () {
              return onShareFailure(data.message);
            });
          }
        });
      } else {
        return response.json().then(function (data) {
          safeCallback(function () {
            return onShareFailure(data.message);
          });
        });
      }
    }).catch(function (error) {
      safeCallback(function () {
        return onShareError(error);
      });
    });
  };

  var handleShare = function handleShare(e) {
    e.preventDefault();
    var senderNameError = validateSenderName(senderName);
    var recipientsError = validateRecipients(recipients);
    var emailBodyError = validateEmailBody(emailBody);
    setSenderNameError(senderNameError);
    setRecipientsError(recipientsError);
    setEmailBodyError(emailBodyError);
    if (senderNameError || recipientsError || emailBodyError) {
      var errorMessage = fieldErrorMessage(senderNameError, recipientsError, emailBodyError, 'Please correct the fields in red before submitting.');
      onValidationError(errorMessage);
      return;
    }
    shareDesign();
  };

  var renderFields = function renderFields() {
    // Input classnames
    var senderNameInputClasses = classnames('rc-ShareForm-input', 'rc-Input', { 'rc-Input--error': senderNameError });
    var recipientsInputClasses = classnames('rc-ShareForm-input', 'rc-Input', { 'rc-Input--error': recipientsError });
    var emailBodyClasses = classnames('rc-ShareForm-input', 'rc-ShareForm-emailBody', 'rc-Input', { 'rc-Input--error': emailBodyError });
    return React__default.createElement(
      'div',
      { className: 'rc-ShareEmailForm-fields' },
      React__default.createElement(
        'div',
        { className: 'rc-ShareEmailForm-inputGroup' },
        React__default.createElement(
          'label',
          { className: 'rc-FormLabel', htmlFor: 'recipients' },
          'To'
        ),
        React__default.createElement('input', {
          className: recipientsInputClasses,
          id: 'recipients',
          onChange: function onChange(e) {
            return setRecipients(e.target.value);
          },
          placeholder: 'hername@example.com, hisname@example.com, theirname@example.com',
          type: 'text',
          value: recipients
        }),
        React__default.createElement(
          'span',
          { className: 'rc-Input-helpText' },
          'Enter email addresses separated by commas.'
        )
      ),
      React__default.createElement(
        'div',
        { className: 'rc-ShareEmailForm-inputGroup' },
        React__default.createElement(
          'label',
          { className: 'rc-FormLabel', htmlFor: 'senderName' },
          'From'
        ),
        React__default.createElement('input', {
          className: senderNameInputClasses,
          id: 'senderName',
          onChange: function onChange(e) {
            return setSenderName(e.target.value);
          },
          placeholder: 'Jane Smith',
          type: 'text',
          value: senderName
        }),
        React__default.createElement(
          'span',
          { className: 'rc-Input-helpText' },
          'Enter your name'
        )
      ),
      React__default.createElement(
        'div',
        { className: 'rc-ShareEmailForm-inputGroup' },
        React__default.createElement(
          'label',
          { className: 'rc-FormLabel', htmlFor: 'emailBody' },
          'Your Message:'
        ),
        React__default.createElement('textarea', {
          className: emailBodyClasses,
          id: 'emailBody',
          onChange: function onChange(e) {
            return setEmailBody(e.target.value);
          },
          type: 'text',
          value: emailBody
        })
      )
    );
  };

  return React__default.createElement(
    'form',
    {
      className: 'rc-Form rc-ShareEmailForm',
      onSubmit: handleShare },
    renderFields(),
    React__default.createElement(
      'button',
      {
        className: 'rc-cta-Primary rc-ShareEmailForm-submit',
        type: 'submit' },
      'SHARE'
    )
  );
}

ShareEmailForm.propTypes = {
  compositeId: propTypes.string.isRequired,
  onValidationError: propTypes.func.isRequired,
  onShareSuccess: propTypes.func.isRequired,
  onShareError: propTypes.func.isRequired,
  designURL: propTypes.string.isRequired
};

ShareEmailForm.displayName = 'ShareEmailForm';

module.exports = {
  Search: Search,
  Button: Button,
  ProductColorSwatch: ProductColorSwatch,
  ShareMenu: ShareMenu,
  ShareEmailForm: ShareEmailForm
};
